const focussableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

export default {
  mounted: (el: HTMLElement) => {
    if (el.matches(focussableElements)) el.focus();
    else el.querySelector<HTMLElement>(focussableElements)?.focus();
  },
};
